import { axiosAuth } from '@/services/http/axios'
import { serialize } from '@/services/object'

const state = {
  all: [],
  list: [],
  filtros: {
    page: 1,
    order: ['created_at', 'desc']
  },
  lastPage: 1
}

const mutations = {
  CHANGEFILTRO (state, params) {
    state.filtros = Object.assign({}, state.filtros, params)
  },
  SETAll (state, payload) {
    state.all = payload
  },
  SETLIST (state, payload) {
    state.list = payload.data
    state.lastPage = payload.lastPage
  }
}

const actions = {
  async all ({ commit, state }) {
    let { data } = await axiosAuth.get(`/arquivo?all=1&order[]=created_at&order[]=desc`)
    commit('SETAll', data)
  },
  async list ({ commit, state }, params = {}) {
    commit('CHANGEFILTRO', params)
    let { data } = await axiosAuth.get(`/arquivo?${serialize(state.filtros)}`)
    commit('SETLIST', data)
  },
  async get ({ commit, state }, id) {
    let { data } = await axiosAuth.get(`/arquivo/${id}`)
    return data
  },
  async add ({ commit, state }, dados) {
    let { data } = await axiosAuth.post(`/arquivo`, dados)
    return data
  },
  async edit ({ commit, state }, dados) {
    let { data } = await axiosAuth.put(`/arquivo/${dados.id}`, dados)
    return data
  },
  async remove ({ commit, state }, id) {
    let { data } = await axiosAuth.delete(`/arquivo/${id}`)
    return data
  }
}

export default { namespaced: true, state, mutations, actions }
